class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.dataset.endDate).getTime();
    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');
    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const distance = Math.max(0, this.endDate - Date.now());

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (distance <= 0) {
      clearInterval(this.interval);
      this.classList.add('countdown-timer--ended');
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
